import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getIsActiveAndAssignedToVariantAcq136 } from '../experiments/acq136/acq136Selectors';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { clearError } from '../store/error/action-creators';
import { completeStepAction } from '../store/flow/action-creators';
import { retryEndpoint } from '../store/http-responses/action-creators';
import { getEndpointStatus } from '../store/http-responses/selectors';
import { HttpStatus } from '../store/http-responses/types';
import { Step } from '../views/Step';
import { EndpointKey } from './EndpointKey';
export const useRetryEndpoint = () => {
  const isAcq136Variant = useSelector(getIsActiveAndAssignedToVariantAcq136);
  const {
    currentStep
  } = useCurrentStep();
  const dispatch = useDispatch();
  const signupRequestEndpointStatus = useSelector(state => getEndpointStatus(state, EndpointKey.Signup));
  const [isLoading, setIsLoading] = useState(false);

  const handleLoadingOnRetry = () => {
    if (isAcq136Variant) {
      setIsLoading(true);
    }
  };

  useEffect(() => {
    if (isAcq136Variant && currentStep === Step.HubletSelection && isLoading && signupRequestEndpointStatus === HttpStatus.Success) {
      dispatch(completeStepAction({
        stepKey: Step.HubletSelection
      }));
      dispatch(clearError());
    }
  });
  return {
    retryEndpoint: (endpointKey, timeout) => retryEndpoint(endpointKey, timeout, isAcq136Variant),
    isLoading,
    handleLoadingOnRetry
  };
};